import Cart from '../components/Modal/Cart.vue'

import { USlideover } from '#components'

export const useCartModal = () => {
  const overlay = useOverlay()
  const modal = useState<ReturnType<typeof overlay.create>>('cartModal')
  const $cart = ref<InstanceType<typeof Cart>>()
  const entryNonce = useState('cartModalEntryNonce', () => 0)

  const route = useRoute()

  watch(() => [route.path], () => {
    modal.value?.close()
  })

  function initCartModal() {
    modal.value = overlay.create(
      h(
        USlideover,
        {
          class: 'max-w-150',
          close: false,
          ui: {
            body: 'flex flex-col',
          },
        },
        {
          body: () =>
            h(Cart, {
              key: entryNonce.value,
              ref: $cart,
              onClose: () => modal.value?.close(),
              class: 'flex-1',
            }),
        },
      ),
    )
  }

  function open() {
    entryNonce.value++

    if (!modal.value) {
      initCartModal()
    }

    modal.value?.open()
  }

  return {
    open,
  }
}
